(function ($) {
    $(window).on('load', function () {
        if ($("#uber").hasClass("interior")) {
            if (window.location.hash) {
                anchorOffset(window.location.hash.substring(1));
            }
        }

        $('#gsc-i-id1').attr('placeholder', 'What are you looking for?');

        alertBarControl();
        wrapMainLinks(['.mainNavItem', '#topNav ul li a', '.backToHome', '.landingMainNav ul li a', '.emergencyBarText .btn']);
    });

    $('#printAreaContent a[href*=#]:not([href=#]), #printAreaContentDotNet a[href*=#]:not([href=#]), #skipContentLink').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + decodeURI(this.hash.slice(1)).replace(/\s|[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '') + ']');
            if (target.parents('.AccordionContent').length || target.parents('.AccordionTrigger').length) { //if clicking accordion link or link in accordion

                if (target.parents('.AccordionTrigger').length) {
                    target.closest('.AccordionTrigger').addClass('open');
                    target.closest('.AccordionTrigger').next().slideDown("100");
                } else if (target.parents('.AccordionContent').length) {
                    $('.AccordionContent:visible').slideUp("100");
                    $('.AccordionTrigger').removeClass('open');
                    target.parents('.AccordionContent').slideDown("100");
                    target.parents('.AccordionContent').prev().addClass('open');
                }
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - headerHeight //Offset scroll position of anchor link for sticky header
                    }, 1000);
                    target.focus();
                    return false;
                }
            } else if (target.length) {
                $viewport.stop().animate({
                    scrollTop: target.offset().top - headerHeight //Offset scroll position of anchor link for sticky header
                }, 1000);
                target.focus();
                return false;
            }
        }
    });

    function anchorOffset(anchor) {
        // Offset scroll position of anchor link for sticky header
        var anchorIsEl = true;
        if (anchor.match("^#")) {
            anchor = anchor.replace("#", "");
        }

        if ($("[name=" + anchor + "]").parents('.AccordionTrigger').length) {
            $("[name=" + anchor + "]").closest('.AccordionTrigger').addClass('open');
            $("[name=" + anchor + "]").closest('.AccordionTrigger').next().slideDown("100");
        } else if ($("[name=" + anchor + "]").parents('.AccordionContent').length) {
            $('.AccordionContent:visible').slideUp("100");
            $('.AccordionTrigger').removeClass('open');
            $("[name=" + anchor + "]").parents('.AccordionContent').slideDown("100");
            $("[name=" + anchor + "]").parents('.AccordionContent').prev().addClass('open');
        }

        if (anchor != "") {
            if ($("[name=" + anchor + "]").length > 0) {
                anchor = $("[name=" + anchor + "]");
            } else if ($("#" + anchor).length > 0) {
                anchor = $("#" + anchor);
            } else {
                anchorIsEl = false;
            }
            if (anchorIsEl) {
                var offsetTop = anchor.offset().top;
                if ($(window).height() > 500) {
                    offsetTop = offsetTop - $("header").height();
                }
                $("html, body").animate({
                    scrollTop: offsetTop
                },
                    1000
                );
            }
        }
    }

    function alertBarControl() {
        var alertBars = $('.emergencyBarWrapper');

        alertBars.each(function () {
            var me = $(this),
                closeBtn = me.find('.closeBtn'),
                color = me.attr('id').replace('emergencyBarWrapper', '').toLowerCase(),
                hasClosed = sessionStorage.getItem(color + 'AlertBarClosed');

            if (hasClosed === null || hasClosed === undefined) {
                me.slideDown(600);

                closeBtn.on('click', function () {
                    me.slideUp(600);
                    sessionStorage.setItem(color + 'AlertBarClosed', true);
                })
            }
        })
    }

    function DropDown(el) {
        this.dd = el;
        this.initEvents();
    }

    DropDown.prototype = {
        initEvents: function () {
            var obj = this;
            obj.dd.on('click', function (event) {
                $(this).toggleClass('active').attr('aria-expanded', function (index, attr) {
                    return attr === 'false' ? 'true' : 'false';
                });
                event.stopPropagation();
            });
        }
    }

    var dd = new DropDown($('#accessibility-button'));

    $(document).click(function (e) {
        if (!$(e.target).closest('#accessibility-dropdown .dropdown:visible').length > 0) {
            $('#accessibility-dropdown').removeClass('active');
            $('#accessibility-button').removeClass('active');
        }
    });

    $(document).keydown(function (event) {
        if (event.keyCode == 27 && ($("#accessibility-button").hasClass('active'))) { // Esc
            $('.accessibility-dropdown').removeClass('active');
            $('#accessibility-button').toggleClass('active').attr('aria-expanded', 'false');
            $("#accessibility-button").focus();
        }
        if (event.keyCode == 13) {
            if ($('#accessibility-button').is(':focus')) {
                $('#accessibility-button').toggleClass('active').attr('aria-expanded', function (index, attr) {
                    return attr === 'false' ? 'true' : 'false';
                });
            }
        }
    });

    $('#accessibility-button').on('keypress click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $('#accessibility-dropdown').toggleClass('active').attr('aria-expanded', function (index, attr) {
            return attr === 'false' ? 'true' : 'false';
        });

        if ($('#accessibility-dropdown').is('.active')) {
            trap_focus($('#accessibility-dropdown'), 'accessibility_dd');
        } else {
            remove_trap_focus($('#accessibility-dropdown'), 'accessibility_dd');
        }
    });

    function wrapMainLinks(els) {
        for (var i = 0; i < els.length; i++) {
            $(els[i]).wrapInner('<span></span>');
        }
    }

    $(window).on('load resize', function () {
        var win = $(this),
            footerL = $('.footerLeft');

        if (footerL.length > 0) {
            if (win.width() >= 992) {
                footerL.detach().insertAfter($('.footerRight'));
            } else {
                footerL.detach().insertBefore($('.footerRight'));
            }
        }
    });
})(jQuery);
